import { verticalContentSelector } from './base';

/**
 * Selector to get all brandable media content (ie: image, video, etc)
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The content from enterprise branding service
 *
 * @see https://dev.azure.com/ctmaus/CTM/_git/ctm-enterprise-branding for schema
 */
export const verticalMediaContentSelector = (state) => {
    return verticalContentSelector(state).get('media');
};

/**
 * Selector to get all brandable link content (ie: urls, file paths, etc)
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The content from enterprise branding service
 *
 * @see https://dev.azure.com/ctmaus/CTM/_git/ctm-enterprise-branding for schema
 */
export const verticalLinkContentSelector = (state) => {
    return verticalContentSelector(state).get('links');
};

/**
 * Selector to get all brandable copy content (ie: text, descriptions, labels, etc)
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The content from enterprise branding service
 *
 * @see https://dev.azure.com/ctmaus/CTM/_git/ctm-enterprise-branding for schema
 */
export const verticalCopyContentSelector = (state) => {
    return verticalContentSelector(state).get('copy');
};

// Gets the image url use for rendering the header logo
export const getHeaderUrl = (state) => verticalMediaContentSelector(state).get('header_logo_image_url');

// Gets the image url use for rendering a smaller version of the header logo (<1440px)
export const getSmallHeaderUrl = (state) => verticalMediaContentSelector(state).get('header_logo_image_url_small');

// Gets the href link to navigate to when clicking the header logo
export const getHeaderLink = (state) => verticalLinkContentSelector(state).get('header_logo_image_link');

// Gets the image url use for rendering the header logo
export const getWelcomeBackHeroImageUrl = (state) => verticalMediaContentSelector(state).get('welcome_back_hero_image_url');

// Gets the image url use for rego lookup hero image
export const getRegoLookupLoadingScreenHeroUrl = (state) => verticalMediaContentSelector(state).get('rego_lookup_loading_screen_hero_image_url');

/**
 * Selector to get the licence plate placeholder text
 * @param {Immutable.Map} state - The full application state
 * @returns {String} - The value from enterprise branding service
 *
 * @see https://dev.azure.com/ctmaus/CTM/_git/ctm-enterprise-branding for schema
 */
export const regoLookupLicencePlatePlaceholderSelector = (state) => {
    return verticalCopyContentSelector(state).get('rego_lookup_licence_plate_placeholder');
};

/**
 * Selector to get the default licence plate state label text
 * @param {Immutable.Map} state - The full application state
 * @returns {String} - The value from enterprise branding service
 *
 * @see https://dev.azure.com/ctmaus/CTM/_git/ctm-enterprise-branding for schema
 */
export const regoLookupDefaultLicencePlateStateLabelSelector = (state) => {
    return verticalCopyContentSelector(state).get('rego_lookup_default_licence_plate_state_label');
};

export const getExpiredQuoteImageSelector = (state) => {
    return verticalMediaContentSelector(state).get('quote_expired_screen_image_url');
};
